





















































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator'
import usersAApi from '@/api/users-a'
import {ICreateUserPopup, SelectOption, UserAdminTableFiltersJson, UserATableDto} from "@/global";
import * as enums from '@/global-enum'
import CreateUserPopup from "@/components/CreateUserPopup.vue";
import ContainerLoading from "@/components/ContainerLoading.vue";
import debounce from "debounce";

@Component({
    components: {CreateUserPopup, ContainerLoading}
})
export default class AdminAccess_Users extends Vue {
    scrollbarSettings = {
        suppressScrollY: true
    };

    table = {
        isLoading: false,
        currentPage: 1,
        totalCount: -1,

        fields: [
            {
                key: 'actions',
                label: ''
            },
            {
                key: 'username',
                label: 'Логін'
            },
            {
                key: 'fullName',
                label: 'ПІБ'
            },
            {
                key: 'organizationName',
                label: 'Організація'
            },
            {
                key: 'positionName',
                label: 'Посада'
            },
            {
                key: 'mapRegionDisplayName',
                label: 'Область'
            },
            {
                key: 'mapDistrictDisplayName',
                label: 'Район'
            },
            {
                key: 'mapPointDisplayName',
                label: 'Місто'
            },
            {
                key: 'createdOn',
                label: 'Створений'
            },
        ]
    };

    filters: UserAdminTableFiltersJson = {
        isNeedActive: true,
        userAccess: <number | null>null,
        username: <string>'',
        fullName: <string>'',
        mapRegionId: <number | null>null,
        mapDistrictId: <number | null>null,
        mapPointId: <number | null>null,
        organizationId: <number | null>null,
        positionName: <string>'',
    };

    activeTableMode = 0;
    isUserIsDisabledCheckboxDisabled = false;
    isTableNeedsReload = false;

    isNeedDisabledOptions = [
        { text: 'Всі', value: null },
        { text: 'Активні', value: true },
        { text: 'Відключені', value: false },
    ];
    userAccessTypeOptions = [
        { label: 'Адміністратор ВТМ / ВММ', id: enums.UserAccessType_Users },
        { label: 'Редагування Бази знань', id: enums.UserAccessType_KnowledgeBase },
    ];
    allMapRegions: SelectOption[] = [];
    allMapDistricts: SelectOption[] = [];
    allMapPoints: SelectOption[] = [];

    availableOrganizations: SelectOption[] = [];

    mounted() {
        this.initData();
    }

    get filterWatch() {
        return [this.filters.isNeedActive, this.filters.userAccess, this.filters.mapRegionId, this.filters.mapDistrictId, this.filters.mapPointId, this.filters.organizationId];
    }

    get filterWatchWithTimer() {
        return [this.filters.username, this.filters.fullName, this.filters.positionName];
    }

    get isFilterUsernameValidFalseOnly() {
        return this.$helpers.isNotEmpty(this.filters.username) ? (this.filters.username.length >= this.$const.selectSearchTermMinLength ? null : false) : null;
    }

    get isFilterUsernameErrorTooltipShowed() {
        return this.isFilterUsernameValidFalseOnly === false;
    }

    get isFilterFullNameValidFalseOnly() {
        return this.$helpers.isNotEmpty(this.filters.fullName) ? (this.filters.fullName.length >= this.$const.selectSearchTermMinLength ? null : false) : null;
    }

    get isFilterFullNameErrorTooltipShowed() {
        return this.isFilterFullNameValidFalseOnly === false;
    }

    get isFilterPositionNameValidFalseOnly() {
        return this.$helpers.isNotEmpty(this.filters.positionName) ? (this.filters.positionName.length >= this.$const.selectSearchTermMinLength ? null : false) : null;
    }

    get isFilterPositionNameErrorTooltipShowed() {
        return this.isFilterPositionNameValidFalseOnly === false;
    }

    tableItemsProvider(ctx, callback: (items: UserATableDto[]) => void) {
        this.table.isLoading = true;

        usersAApi.usersForTable(this.table.currentPage, this.filters, usersResult => {
            callback(usersResult.items);

            this.table.totalCount = usersResult.totalCount;
            this.table.isLoading = false;
        }, errorMessage => {
            callback([]);

            this.table.isLoading = false;
        });

        return null;
    }

    tableRowClass(item: UserATableDto) {
        if (item.isDisabled) return "table-danger";
        return '';
    }

    showNotification(title: string, message: string, variant: string) {
        if (!this.$helpers.isNotEmpty(message)) return;

        this.$bvToast.toast(message!, {
            title: title,
            variant: variant
        })
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    async initData() {
        await this.updateMapLookups();

        await usersAApi.adminAvailableOrganizations(((organizations) => {
            this.availableOrganizations = this.$appUtils.getAvailableOrganizationOptions(organizations);
        }), this.showError);

        await usersAApi.getUsersTableFilters((filters => {
            if (this.$helpers.isExists(filters)) {
                this.$withoutWatchers(() => {
                    this.filters = filters;
                });

                this.forceUpdateTable(false);
            }
        }), this.showError);
    }

    async onMapElementsChanged(isRegionChanged: boolean, isDistrictChanged: boolean) {
        if (isRegionChanged) {
            if (this.$helpers.isNumeric(this.filters!.mapDistrictId)) {
                this.filters!.mapDistrictId = null;
            }
            if (this.$helpers.isNumeric(this.filters!.mapPointId)) {
                this.filters!.mapPointId = null;
            }
        }
        else if (isDistrictChanged) {
            if (this.$helpers.isNumeric(this.filters!.mapPointId)) {
                this.filters!.mapPointId = null;
            }
        }

        await this.updateMapLookups();
    }

    toggleUserIsDisabled(user: UserATableDto) {
        if (!this.$helpers.isExists(user)) return;

        this.isUserIsDisabledCheckboxDisabled = true;

        let newIsDisabled =  !user!.isDisabled;

        usersAApi.disableEnableUser(user!.id, newIsDisabled, data => {
            if (data.success) {
                user!.isDisabled = newIsDisabled;

                this.showNotification("Статус змінено",
                    `Абонент \"${user.fullName}\" ${user.isDisabled ? 'відключений' : 'включений'}`,
                    user.isDisabled ? 'warning' : 'success');

                this.isTableNeedsReload = true;
            } else {
                this.$nextTick(() => {
                    user!.isDisabled = !newIsDisabled;
                });
            }

            this.isUserIsDisabledCheckboxDisabled = false;
        }, errorMessage => {
            this.showError(errorMessage);

            this.$nextTick(() => {
                user!.isDisabled = !newIsDisabled;
            });

            this.isUserIsDisabledCheckboxDisabled = false;
        })
    }

    async updateMapLookups() {
        const thisInst = this;

        const mapRegionId = this.$helpers.isExists(this.filters) ? this.filters!.mapRegionId : null;
        const mapDistrictId = this.$helpers.isExists(this.filters) ? this.filters!.mapDistrictId : null;

        await this.$appUtils.generateMapSelectOptions(mapRegionId, mapDistrictId, (mapRegions, mapDistricts, mapPoints) => {
            thisInst.allMapRegions = mapRegions;
            thisInst.allMapDistricts = mapDistricts;
            thisInst.allMapPoints = mapPoints;
        }, this.showError);
    }

    openCreateUserPopup() {
        if (!this.$helpers.isNotEmptyArray(this.availableOrganizations)) return;

        const createUserPopup = this.$refs.createUserPopup as unknown as ICreateUserPopup;
        createUserPopup.openCreateUserPopup(this.availableOrganizations);
    }

    @Watch("filterWatch")
    onFilterWatchChanged(val: any, oldval: any) {
        this.forceUpdateTable(true);
    }

    @Watch("filterWatchWithTimer")
    onFilterWatchWithTimerChanged(val: any, oldval: any) {
        this.forceUpdateTableWithTimer(true);
    }

    forceUpdateTableWithTimer = debounce((isNeedSaveFilters: boolean) => {
        this.forceUpdateTable(isNeedSaveFilters);
    }, 750);

    forceUpdateTable(isNeedSaveFilters: boolean) {
        (<any>this.$refs.usersTable).refresh();

        if (isNeedSaveFilters) {
            usersAApi.usersTableFiltersSave(this.filters, data => {
                if (data.success) {
                    // console.log("Filters saves");
                }
            }, errorMessage => {
                console.error("Filters save error" + errorMessage);
            });
        }

        this.isTableNeedsReload = false;
    }
}
